// extracted by mini-css-extract-plugin
export default {"leather-text-container":"leather_leather-text-container__0PBXe","leather-image-container":"leather_leather-image-container__NYv8p"};